import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { getColor } from '../../core/themev3';

const ring = keyframes`
	from {
		transform: rotate(0deg);
	}
	to {
	  transform: rotate(360deg);
	}
`;

const SpinnerWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const SpinnerRing = css`
  left: ${({ size }) => ((parseInt(size) / 2) * -1).toString()}px;
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border: ${({ lineWidth }) => lineWidth}px solid transparent;
  border-radius: 50%;
  animation: ${ring} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${({ color }) => color} transparent transparent transparent;
`;

const SpinnerChildA = styled.div`
  ${SpinnerRing};
  animation-delay: -0.45s;
`;
const SpinnerChildB = styled.div`
  ${SpinnerRing};
  animation-delay: -0.3s;
`;
const SpinnerChildC = styled.div`
  ${SpinnerRing};
  animation-delay: -0.15s;
`;
const SpinnerChildD = styled.div`
  ${SpinnerRing};
  animation-delay: -0.075s;
`;

export function Spinner(props) {
  const { color = getColor('primary'), size = '32', lineWidth = '4' } = props;

  return (
    <SpinnerWrapper size={size} lineWidth={lineWidth}>
      <SpinnerChildA color={color} size={size} lineWidth={lineWidth} />
      <SpinnerChildB color={color} size={size} lineWidth={lineWidth} />
      <SpinnerChildC color={color} size={size} lineWidth={lineWidth} />
      <SpinnerChildD color={color} size={size} lineWidth={lineWidth} />
    </SpinnerWrapper>
  );
}
